<div id="pcik-location-dialog" class="pcik-location-dialog">
    <mat-toolbar class="mat-accent m-0 dialog-header">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <div class="full-screen-dialog-actions" style="margin-inline-end: 0;">
                <button mat-icon-button (click)="onCancel()" aria-label="Close dialog">
                    <mat-icon>close</mat-icon>  
                </button>
            </div>
            <span class="dialog-title"> {{ data?.title }}</span>

            <div class="full-screen-dialog-actions">
                <button *ngIf="currentState == 1" style="direction: rtl;" mat-flat-button [disabled]="locationForm.get('address_ar').hasError('required') || locationForm.get('address_fr').hasError('required')" (click)="goToNext()">
                    {{'popups.Suivant' | transloco}}
                </button>
                <button *ngIf="currentState == 2" mat-flat-button [disabled]="locationForm.invalid || disableSubmitButton" (click)="onSubmit()">
                    {{'popups.Enregistrer' | transloco}}
                </button>
            </div>

        </mat-toolbar-row>
    </mat-toolbar>

    <div class="dialog-content-wrapper container-event-form">
        <div *ngIf="currentState == 1" class="pb-8 m-0 step1">
            <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="20px" class="w-100-p info-container">
                <p class="info">
                    <span class="big-text">
                        {{'popups.ChoisirAdresse' | transloco}}
                </span>
                </p>
                <mat-icon class="mt-12">info</mat-icon>
            </div>
        </div>

        <form *ngIf="locationForm" fxLayout="column" [@componentTransition]="currentState" [formGroup]="locationForm" (ngSubmit)="onSubmit()">

            <div *ngIf="currentState == 1" class="step1-inputs">
                <div fxLayout="row" fxLayoutWrap class="w-100-p">
                    <div fxFlex="100">
                        <mat-form-field appearance="outline" class="w-100-p">
                            <mat-label>{{'popups.adressefrancaise' | transloco}}</mat-label>
                            <input id="title_fr" matInput formControlName="address_fr" required>
                            <mat-error *ngIf="locationForm.get('address_fr').hasError('required')">
                            {{'popups.ChampObligatoire' | transloco}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row" fxLayoutWrap class="w-100-p">
                    <div fxFlex="100">
                        <mat-form-field appearance="outline" class="w-100-p">
                            <mat-label>>{{'popups.adressearabe' | transloco}}</mat-label>
                            <input dir="rtl" id="title_ar" matInput formControlName="address_ar" class="address_ar" required>
                            <mat-error *ngIf="locationForm.get('address_ar').hasError('required')">
                                 {{'popups.ChampObligatoire' | transloco}}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div fxLayout="row" *ngIf="currentState == 2" fxLayoutWrap class="w-100-p step2-map">
                <div fxFlex="100" style="height: 400px; margin-top: 16px;">
                    <google-map [zoom]="zoom" (mapInitialized)="mapReadyHandler()" [center]="initialCenter" [options]="mapOptions" height="100%" width="100%" style="border-radius: 4px;">
                        <map-marker [position]="markerPosition" [options]="markerOptions" (mapClick)="clickedMarker()" (mapDragend)="markerDragEnd($event)">
                        </map-marker>
                        <map-info-window>
                            <strong> {{'popups.emplacement de votre établissement' | transloco}}</strong>
                        </map-info-window>
                    </google-map>
                </div>

                <div style="display: none;">
                    <input formControlName="lat">
                    <input formControlName="lng">
                </div>
            </div>
        </form>
        <div *ngIf="errors" class="py-16 mx-0 my-16 error-message" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <mat-icon color="warn">error_outline</mat-icon>
            <span class="text">{{ errorMessage }}</span>
        </div>
        <button *ngIf="currentState == 2" (click)="getLocation()" mat-stroked-button color="primary" class="set-location-button">
            <mat-icon>my_location</mat-icon> {{'popups.Ma localisation' | transloco}}
        </button>

    </div>
    <div class="basic-dialog-actions">

        <button *ngIf="currentState == 1" (click)="onCancel()" mat-stroked-button>
                {{ 'popups.Annuler' | transloco }}
            </button>
        <button *ngIf="currentState == 2" (click)="goToPrevious()" mat-stroked-button>
                {{ 'popups.Precedent' | transloco }}
                <mat-icon>navigate_before</mat-icon>
            </button>
        <button *ngIf="currentState == 1" mat-flat-button color="primary" class="save-button mat-accent" style="direction: rtl;" aria-label="NEXT" [disabled]="locationForm.get('address_ar').hasError('required') || locationForm.get('address_fr').hasError('required')" (click)="goToNext()">
            <span>{{'popups.Suivant' | transloco}}</span>
            <mat-icon>navigate_next</mat-icon>
        </button>

        <button *ngIf="currentState == 2" 
            mat-flat-button 
            color="primary" 
            class="save-button mat-accent" 
            aria-label="SAVE" 
            [disabled]="locationForm.invalid || disableSubmitButton || (!isPositionModified && !isAddressModified)" 
            (click)="onSubmit()">
            {{ 'popups.Enregistrer' | transloco }}
        </button>
    </div>

</div>